import React from 'react';
import LoginPage from './LoginPage';
import { connect } from 'react-redux';
import { accountActions } from '../../../actions/account.action';
import permissionsActions from '../../../actions/permissions.actions';
import { generalActions } from '../../../actions/general.action';
import { configureActions } from '../../../actions/configure.action';
import { bindActionCreators } from 'redux';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      error: '',
    };
  }

  componentDidMount() {
    this.props.generalActions.clearError();
    this.props.accountActions.logout();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.account.error !== prevState.error) {
      state.error = nextProps.account.error;
    }
    return Object.keys(state).length ? state : null;
  }

  onLogin = (loginData) => {
    this.setState({ isSubmitting: true }, async () => {
      await this.props.accountActions
        .login(loginData)
        .then(async () => await this.props.generalActions.getCurrentProfile())
        .then(
          async () =>
            await this.props.configureActions.getDeptSettingsInLogin('en_US'),
        )
        .then(
          async () =>
            await this.props.permissionsActions.getCurrentUserPermissions(),
        )
        .then(() => {
          let { from } = this.props.location.state || {
            from: { pathname: '/' },
          };
          this.props.history.push(from);
        })
        // .then(async () => {
        //   await this.props.accountActions
        //     .checkPasswordExpired()
        //     .then((isExpired) => {
        //       if (isExpired) {
        //         this.props.history.push('/change-password');
        //       } else {
        //         let { from } = this.props.location.state || {
        //           from: { pathname: '/' },
        //         };
        //         this.props.history.push(from);
        //       }
        //     });
        // })
        .catch(() => this.setState({ isSubmitting: false }));
    });
  };

  render() {
    return <LoginPage {...this.state} onLogin={this.onLogin} />;
  }
}

function mapStateToProps(state) {
  return {
    account: state.account,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(
      Object.assign({}, accountActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    permissionsActions: bindActionCreators(
      Object.assign({}, permissionsActions),
      dispatch,
    ),
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
